import { onScene } from '@/mocks/chaoyang';
import { toneBadge, toneDot } from './tones';

export default function Timeline() {
  return (
    <section id="scene" className="scroll-mt-24 py-10 md:py-14">
      <div className="chigua-container">
        <div className="flex flex-wrap items-end justify-between gap-3 pb-2">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-teal-500/10 px-3 py-1 text-xs font-bold text-teal-700 ring-1 ring-teal-500/20">
              <i className="ri-camera-lens-fill text-sm"></i>
              时间线 · 现场速递
            </span>
            <h2 className="mt-3 text-2xl font-black tracking-tight text-stone-900 md:text-3xl">现场速递</h2>
            <p className="mt-1 text-sm text-stone-600">按时间倒序回放各路现场，围观不迷路，后续有更新随时补。</p>
          </div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-white px-3 py-1.5 text-xs font-semibold text-teal-700 ring-1 ring-teal-500/20">
            <i className="ri-broadcast-line"></i>
            实时播报中
          </span>
        </div>

        <div className="mt-8 space-y-5">
          {onScene.map((s, i) => (
            <div key={i} className="relative pl-9 md:pl-11">
              <span className="absolute left-[10px] top-0 h-full w-0.5 bg-orange-500/15 md:left-[13px]"></span>
              <span className={`absolute left-0 top-1 flex h-5 w-5 items-center justify-center rounded-full text-white md:left-1 md:h-6 md:w-6 ${i % 2 === 0 ? 'bg-orange-500' : 'bg-teal-500'}`}>
                <i className={`${i % 2 === 0 ? 'ri-flashlight-line' : 'ri-zoom-in-line'} text-[11px] md:text-xs`}></i>
              </span>
              <div className="rounded-2xl bg-white p-4 ring-1 ring-black/5 md:p-5">
                <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
                  <span className="inline-flex items-center gap-1 text-xs font-bold text-stone-400">
                    <i className="ri-time-line text-orange-500"></i>
                    {s.time}
                  </span>
                  <span className="inline-flex items-center gap-1 text-xs font-semibold text-stone-600">
                    <i className="ri-map-pin-2-line text-red-500"></i>
                    {s.place}
                  </span>
                  <span className={`rounded-md px-2 py-0.5 text-[11px] font-bold ring-1 ${toneBadge[s.tone]}`}>
                    <span className={`mr-1 inline-block h-1.5 w-1.5 rounded-full align-middle ${toneDot[s.tone]}`}></span>
                    {s.tag}
                  </span>
                </div>
                <h3 className="mt-2 text-[15px] font-bold leading-snug text-stone-900 md:text-lg">{s.title}</h3>
                <p className="mt-1 text-[13px] leading-relaxed text-stone-600">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 flex items-center justify-center gap-2 rounded-2xl border border-dashed border-orange-500/30 bg-orange-500/5 px-4 py-3 text-xs text-stone-500">
          <i className="ri-arrow-down-s-line text-orange-500"></i>
          更多现场画面正在回传整理中，稍后陆续上架
        </div>
      </div>
    </section>
  );
}